export const allowedContentTypes = {
  'image': ['image/png', 'image/jpg', 'image/jpeg', 'image/webp'],
  'pdf': ['application/pdf'],
}

export const maxSize = {
  'image': 5 * 1024 * 1024, // 5MB
  'pdf': 100 * 1024 * 1024, // 100MB
}
